export const BENI_FEATURE_FLAGS = {
  APP: 'app.benchmark_insight',
  DATA: 'benchmark_insight.data',
  DATA_STAFF_ONLY: 'benchmark_insight.data_staff_only',
  MAPPING_VIEW: 'benchmark_insight.pms.view',
  MAPPING_EDIT: 'benchmark_insight.pms.edit',
  EXPORTS: 'benchmark_insight.reports.run_download',
  COMPSET: 'benchmark_insight.compset',
  REFERENCE_PERIOD: 'benchmark_insight.ref_period',
  PICKUP: 'benchmark_insight.pickup',
  FUTURE_DATA: 'benchmark_insight.future_data',
  PACE: 'benchmark_insight.pace',
  TRIAL_UPSELL: 'benchmark_insight.upsell.app',
  TRIAL_UPSELL_EDIT: 'benchmark_insight.upsell.app.edit',
  LIGHT_UPSELL: 'benchmark_insight.light.upsell.app',
  LIGHT_UPSELL_EDIT: 'benchmark_insight.light.upsell.app.edit',
  SEGMENTATION_PARTIAL: 'benchmark_insight.segmentation_partial',
  RANKING: 'benchmark_insight.ranking',
  LENGTH_OF_STAY: 'benchmark_insight.los',
  CHANNEL: 'benchmark_insight.channel',
  SMART_COMPSET_EDIT: 'benchmark_insight.settings.smart_compset.edit',
  TERMS_AND_CONDITIONS_ACCEPT: 'benchmark_insight.terms_and_conditions.accept',
  SETTINGS_COMPSET_VIEW: 'benchmark_insight.settings.compset.view',
  SETTINGS_COMPSET_EDIT: 'benchmark_insight.settings.compset.edit',
  SETTINGS_PORTFOLIO_COMPSET_VIEW:
    'benchmark_insight.settings.internal_compset.view',
  SETTINGS_SMART_COMPSET_EDIT: 'benchmark_insight.settings.smart_compset.edit',
  SETTINGS_SMART_COMPSET_VIEW: 'benchmark_insight.settings.smart_compset.view',
  SMART_COMPSET: 'benchmark_insight.smart_compset',
  ROLE_ADMIN: 'benchmark_insight.role.admin',
  ROLE_WRITER: 'benchmark_insight.role.writer',
} as const;
export type BeniFeatureFlag =
  (typeof BENI_FEATURE_FLAGS)[keyof typeof BENI_FEATURE_FLAGS];
